import React, { useMemo } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { generateUid } from "../../utils/generateUid";
import styles from "./Breadcrumb.module.scss";
import BreadcrumbItem from "./BreadcrumbItem";

const Breadcrumb = ({ items, children }) => {
  const itemsList = useMemo(() => {
    return (
      items &&
      items.map((item, index) => {
        return (
          <BreadcrumbItem key={generateUid()} isLast={index !== items.length - 1} {...item}>
            {item.node}
          </BreadcrumbItem>
        );
      })
    );
  }, [items]);
  return (
    <ol className={cx(styles.breadcrumb)}>
      {itemsList}
      {React.Children.map(children, (child, index) => {
        return React.cloneElement(child, { isLast: index !== children.length - 1 });
      })}
    </ol>
  );
};

Breadcrumb.Item = BreadcrumbItem;

Breadcrumb.defaultProps = {
  children: undefined,
  items: undefined
};

Breadcrumb.propTypes = {
  children: PropTypes.node,
  /** Defines item style (link | section | subSection) and separator type (> | -) */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.node.isRequired,
      type: PropTypes.string
    }).isRequired
  )
};

export default Breadcrumb;
